import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdIntegrationStatus } from './types';
import { invalidateRegEdIntegration, setRegEdIntegration } from './useRegEdIntegrationQuery';

/**
 * Moves the account between advisor filing and officer filing. The API refuses to turn this on while
 * `enabled` is false, because the review portal's own guard requires both and the link would otherwise
 * be dead on arrival; turning it off is unchecked.
 */
export const useRegEdOfficerFilesSubmissionsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRegEdIntegrationStatus) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			officerFilesSubmissions,
			impersonationContext,
		}: {
			officerFilesSubmissions: boolean;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<IRegEdIntegrationStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { officerFilesSubmissions },
					urlPath: 'compliance/regEd/integration/officerFilesSubmissions',
				}),
				'PUT',
				null
			),
		onError,
		onSuccess: (result, { impersonationContext }) => {
			setRegEdIntegration(impersonationContext?.account?.id, result);
			invalidateRegEdIntegration();
			onSuccess?.(result);
		},
	});
};
